module.exports = __webpack_public_path__ + "img/shape.f3370ada.png";